const baseUrl =
	process.env.NODE_ENV === "production" ? "/" : "https://sbkh.ascentis.com.sg"
const languages = [
	{ name: "English", code: "en" },
	{ name: "Khmer", code: "km" },
]
const currency = "$"
const recaptchaKey =
	process.env.REACT_APP_RECAPCHA_SITE_KEY === "{{REACT_APP_RECAPCHA_SITE_KEY}}"
		? "6LduckwtAAAAAAI1jVq5mQkuFZMuqJAjm88RRP5l"
		: process.env.REACT_APP_RECAPCHA_SITE_KEY ||
		  "6LduckwtAAAAAAI1jVq5mQkuFZMuqJAjm88RRP5l" // SB site key
const appStoreUrl = "https://apps.apple.com/us/app/starbucks-cambodia/id1456402324?ls=1"
const ggStoreUrl = "https://play.google.com/store/apps/details?id=com.starbucks.kh"
const apiWrapperEndpoint = process.env.REACT_APP_WRAPPER_API_ENDPOINT
const maxTransferAmount = 500
const timeoutConfigs = {
	warnTimeoutMins: 12,
	logoutTimeoutMins: 15,
	refreshIntervalMins: 10,
}
const captchaThreshold = 0
const noOfStarsForFreeDrink = 100

export {
	baseUrl,
	languages,
	currency,
	recaptchaKey,
	maxTransferAmount,
	appStoreUrl,
	ggStoreUrl,
	timeoutConfigs,
	captchaThreshold,
	noOfStarsForFreeDrink,
	apiWrapperEndpoint,
}



// WEBPACK FOOTER //
// ./src/configs/Settings.js